import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AppService } from 'src/app/app.service';
import { EncryptionService } from 'src/app/encryption.service';
import { environment } from 'src/environments/environment';
import { LandingService } from '../landing.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ADMIN_CONSTANT } from 'src/app/app.model';

@Component({
  selector: 'app-applicant-details',
  templateUrl: './applicant-details.component.html',
  styleUrls: ['./applicant-details.component.scss']
})
export class ApplicantDetailsComponent implements OnInit {
  ELEMENT_DATA: any[];
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = [ 'studentCode','applicantCode','name', 'category','pwd','meritindOne','gmr','cmr', 'prefNo', 'subjectCombination','applicationDetails'];
  RunCycleId: number;
  CollegeCourseId: number;
  reportBaseUrl: string;
  destroy: Subject<any> = new Subject<any>();
  private readonly AESKey: string;
  constructor
    (
      public dialogRef: MatDialogRef<ApplicantDetailsComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: AppService,
      private encryptionService: EncryptionService,
      private landingService: LandingService,
  ) {
    this.AESKey = environment.encryptionConfig.AES_KEY;
    let adminconfig = this.service.getToken(ADMIN_CONSTANT.ADMIN_TOKEN_ADMIN_CONFIG);
    this.reportBaseUrl = adminconfig.find((eachConfig: any) => eachConfig.ConfigCode === 'CRYSTAL_RPT_URL')?.ConfigValue ?? environment.reportUrl;
}

  ngOnInit(): void {
    this.CollegeCourseId = this.data.CollegeCourseId;
    this.RunCycleId = this.data.RunCycleId;
    this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
    this.getCourseMeritList();
  }
  getCourseMeritList(): void {
    const payload = {
      CollegeCourseId : this.data.CollegeCourseId,
      RunCycleId : null
    }
    this.landingService
      .onCourseMeritListFetch(payload)
      .pipe(takeUntil(this.destroy))
      .subscribe(
        (response) => {

          if (response.Header.Status === ADMIN_CONSTANT.SUCCESS_STATUS) {
            if (response) {
              // console.log(response?.Body?.BusinessData?.Collection)
              this.dataSource = new MatTableDataSource(response?.Body?.BusinessData?.Collection);
            } else {
              this.service.showToast(ADMIN_CONSTANT.NO_RECORDS_FOUND);
            }
          } else if (response.Header.Status === ADMIN_CONSTANT.ERROR_STATUS) {
            this.service.showToast(response.Error.ErrorMessage);
          }
        },
        (err) => this.service.showToast(ADMIN_CONSTANT.SERVER_ERROR_MESSAGE)
      );
  }
  downloadApplicationPDF = (reportId: string, outputFileName: string, StudentId: number) => {
    var reportParam = { StudentId: StudentId, ReportType: null };
    this.openReport(reportId, outputFileName, reportParam);
  }
  private getNowUTCUnFormated(): any {
    const now = new Date();
    return (new Date(now.getTime() + (now.getTimezoneOffset() * 60000)));
  }
  private openReport(reportId: string, outputPdfFileName: string, reportParamObj: object) {
    // const AESKey = '98eb956cd9364a88b6a6048439983370';
    // const reportBaseUrl = 'http://repserver.applythrunet.co.in/PrintReport/ShowReport';
    const reportBaseUrl = environment.reportUrl;

    const twentyMinutesLater = this.getNowUTCUnFormated();
    twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes() + 20);
    const addeddate = formatDate(twentyMinutesLater, 'yyyy-MM-dd HH:mm:ss', 'en');

    const param = {
      reportParam: reportParamObj,
      outputFileName: outputPdfFileName,
      reportType: 'PDF',
      linkExpiryOn: addeddate,
    };
    const encryptText = this.encryptionService.Encrypt(JSON.stringify(param), this.AESKey);
    console.log(JSON.stringify(param));
    console.log(encryptText);
    const URL = this.reportBaseUrl + '?reportcode=' + reportId + '&param=' + encodeURIComponent(encryptText);
    window.open(URL);
  }
  onCancel(): void {
    this.dialogRef.close();
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
